import * as React from 'react';
import { useEffect, useState } from "react"
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Icon, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import dataService from '../services/Data'

export default function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(false);
    const [anchorElUser, setAnchorElUser] = React.useState(false);
    const navigate = useNavigate();
    const { user } = useAuth()

    // Establecer el token cuando user cambie
    useEffect(() => {
        if (user?.data?.token) {
            dataService.setToken(user.data.token);
        }
    }, [user]);

    const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
    };

    const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
    setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    };

    const pages = user?.data?.rol === "Administrador" ? [{ text: 'Cotizador', href: '/cotizador' }, { text: 'Situación', href: '/situacion' }, { text: 'Consultas', href: '/consultas' }, { text: 'Usuarios', href: '/usuarios' }, { text: 'Datos', href: '/datos' }, { text: 'Tasas', href: '/tasas' }] : [{ text: 'Cotizador', href: '/cotizador' }]
    const settings = [{ text: 'Perfil       ', href: '/perfil' }, { text: 'Cerrar Sesión', href: '/logout' }];

  return (
      <AppBar position="static" sx={{ bgcolor: '#D2A120' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters >
          <Link
            href="/"
            underline="none"
            sx={{
              mr: 0.5,
              display: { xs: 'none', md: 'flex' },
            }}
          >
            <img
              className="nav-logo"
              src="../../iconoSS-28x32-blanco.png"
              alt="Porousway Logo"
              width="32"
              height="32"
            />
          </Link>
          {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.20px',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            SmPas
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
                      >
              {pages.map((page) => (
                <MenuItem key={page.text} onClick={() => navigate(page.href)}>
                  <Typography textAlign="center">{page.text}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Link
            href="/"
            underline="none"
            sx={{
              mr: 0.8,
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <img
              className="nav-logo"
              src="../../iconoSS-28x32-blanco.png"
              alt=""
              width="32"
              height="32"
            />
          </Link>
          {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.06rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            SmPas
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.text}
                name={page.text}
                onClick={() => navigate(page.href)}
                sx={{ my: 2, color: 'inherit', display: 'block' }}
              >
                {page.text}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Opciones">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar sx={{ bgcolor: '#D2A120', border: '0.1px solid white' }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting.text} onClick={() => { handleCloseUserMenu, navigate(setting.href) }} >
                  <Typography textAlign="center">
                    <Link underline="none" color="inherit">{setting.text}</Link>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}